import { FC } from 'react'

const Home: FC = () => (
  <section className='layout-width-constraint'>
    <div className='ph8'>
      <h1>User Management</h1>
      <p>Please select the action you wish to take from the navigation menu to continue.</p>
    </div>
  </section>
)

export default Home
